import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "../../../server/routers";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

export const trpc = createTRPCReact<AppRouter>();

// Пока Firebase не восстановил сессию из хранилища, auth.currentUser всегда
// null, и запрос уходил без токена → 401 «Please login (10001)». Внутри общего
// каркаса это не проявлялось: он сам ждёт входа. А страницы вне каркаса
// (печать счёта в новой вкладке) стреляли сразу и после переезда в Астану
// стали проигрывать гонку: сервер отвечает быстрее, чем Firebase просыпается.
// Ждём первое событие состояния входа, дальше оно уже известно навсегда.
const authReady = new Promise<void>(resolve => {
  const stop = onAuthStateChanged(auth, () => {
    stop();
    resolve();
  });
});

/** Типы ответов сервера: RouterOutputs["companies"]["rating"] и т.п. */
export type RouterOutputs = inferRouterOutputs<AppRouter>;

/** Get current Firebase ID token (or null if not signed in) */
export async function getAuthToken(): Promise<string | null> {
  await authReady;
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}
